var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative",class:[
    {
      'select-none': _vm.show,
    } ]},[_vm._t("default"),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"overlay absolute inset-0 z-10 flex justify-center items-center text-black bg-white bg-opacity-50 backdrop-filter backdrop-blur-xs"},[_c('BaseIcon',{staticClass:"w-4 h-4",attrs:{"name":"spinner","spin":""}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }